import type { CommandUnknownOpts } from '@commander-js/extra-typings';
import kebabCase from 'lodash/kebabCase.js';
import type { Panorama } from './createPanorama.js';

export function createCommandTransaction(
  panorama: Panorama,
  command: CommandUnknownOpts
) {
  const commandFullName = kebabCase(getFullCommandName(command));

  panorama.setDefaultClientData({
    commandName: command.name(),
    commandFullName,
  });

  const client = panorama.client({
    baseParams: {
      componentId: 'command',
    },
  });

  return client.transaction(commandFullName);
}

function getFullCommandName(command: CommandUnknownOpts): string {
  if (command.parent) {
    return `${getFullCommandName(command.parent)} ${command.name()}`.trim();
  }
  return command.name();
}
